import { StoreState } from '@/redux/types';
import { getCurrency } from './getCurrency';

export function getCurrencyId(state: StoreState) {
  return getCurrency(state)?.id;
}
